<template>
  <button
    class="flex flex-row border border-1 border-GREY rounded-lg p-3 items-center justify-between w-full"
    @click="emit('itemClick')"
  >
    <div class="flex flex-row justify-start items-center gap-2">
      <div v-if="props.task.icon" class="min-w-10 flex flex-col items-center">
        <div class="rounded-full w-9 h-9 items-center justify-center flex bg-LIGHTGREY">
          <font-awesome-icon
            class="black-icon"
            :icon="
              props.task.icon === 'youtube'
                ? 'fa-brands fa-youtube'
                : props.task.icon === 'twitter'
                  ? 'fa-brands fa-x-twitter'
                  : props.task.icon === 'telegram'
                    ? 'fa-brands fa-telegram'
                    : props.task.icon === 'share'
                      ? 'fa-solid fa-user-astronaut'
                      : 'fa-solid fa-skull'
            "
          />
        </div>
      </div>
      <div class="flex flex-col gap-0.5 items-start justify-center">
        <p class="font-semibold text-sm">{{ props.task.name }}</p>
        <div class="flex flex-row gap-1 justify-center items-center">
          <img src="../assets/icons/token-2.svg" class="w-5 h-5 object-contain" />
          <p class="text-GREY text-sm font-semibold">+{{ props.task.earning_token }}</p>
        </div>
      </div>
    </div>
    <font-awesome-icon class="arrow_icon_color mr-2" icon="fa-solid fa-angle-right" />
  </button>
</template>

<script setup>
const props = defineProps({
  task: {
    type: Object,
    default: () => {}
  }
})

const emit = defineEmits(['itemClick'])
</script>

<style></style>
